// Dependencies
import React from "react";
import { css } from "emotion";
import { Icon } from "antd";

const FetchSpinner = ({ children, loading, text }) => {
  const spinnerTextCss = css`
    display: ${loading ? "flex" : "none"};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    max-height: 480px;
    color: #1890ff;
  `;

  const spinnerContainerCss = css`
    position: relative;
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
  `;

  const spinnerBlurCss = css`
    clear: ${loading ? "both" : "none"};
   overflow: ${loading ? "hidden" : "visible"};
   opacity: ${loading && "0.3"}
   -webkit-user-select: ${loading ? "none" : "auto"};
   -moz-user-select: ${loading ? "none" : "auto"};
   -ms-user-select: ${loading ? "none" : "auto"};
   user-select: ${loading ? "none" : "auto"};
   pointer-events: ${loading ? "none" : "auto"};
  `;

  return (
    <div
      className={css`
        position: relative;
      `}
    >
      <div className={spinnerTextCss}>
        <Icon
          type="sync"
          spin
          className={css`
            font-size: 36px;
          `}
        />
        <div
          className={css`
            font-size: 24px;
            margin-top: 10px;
          `}
        >
          {text}
        </div>
      </div>
      <div className={`${spinnerBlurCss} ${spinnerContainerCss}`}>
        {children}
      </div>
    </div>
  );
};

export default FetchSpinner;
